import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { CreateUpdateDistrictTranslationEntity } from './CreateUpdateDistrictTranslationEntity'

export class RegionDistrictEntity {
  id?: number
  name?: string | null
  boundaryData?: Array<LngLatEntity> | null
  boundary?: Array<LngLatEntity> | null
  numberOfRestaurants?: number
  translations?: Array<CreateUpdateDistrictTranslationEntity>
  numberOfBranches?: number
  disabled?: boolean
}
